import { render, staticRenderFns } from "./profile-followers.vue?vue&type=template&id=4cdce9d8&"
import script from "./profile-followers.vue?vue&type=script&lang=js&"
export * from "./profile-followers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports